/**
 * Utility functions for Leave Management
 */

import { LeaveStatus } from '../types/leave.types';
import { STATUS_COLORS } from '../constants/leave.constants';

/**
 * Calculate the duration in days between two dates (inclusive)
 */
export const calculateDuration = (start: Date | null, end: Date | null): number => {
    if (!start || !end) return 0;
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
};

/**
 * Format a date string to localized format
 */
export const formatDate = (dateString: string): string => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
};

/**
 * Get the color for a leave status badge
 */
export const getStatusColor = (status: string): string => {
    return STATUS_COLORS[status as LeaveStatus] || 'gray';
};

/**
 * Get today's date with time set to midnight
 */
export const getTodayMidnight = (): Date => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};

/**
 * Get yesterday's date with time set to midnight
 */
export const getTomorrowMidnight = (): Date => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0);
    return today;
};

/**
 * Get yesterday's date with time set to end of day
 */
export const getYesterdayEndOfDay = (): Date => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    today.setHours(23, 59, 59, 999);
    return today;
};

/**
 * Normalize a date to midnight (removes time component)
 */
export const normalizeDateToMidnight = (date: Date): Date => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
};
/**
 * Format a Date object to YYYY-MM-DD string in local time
 */
export const formatDateToISO = (date: Date | null): string => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
